import React from 'react';
import { useHistory } from 'react-router';
import { completedRoutes } from '../../../common/constants';
import { useTranslation } from 'react-i18next';

function UserPlacesItem(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    name, typename, address, likengo_id: id,
    active_task_count: activeTaskCount,
  } = props.item;

  const handleClick = () => {
    history.push(completedRoutes.taskOwnerInfo(id), { placeId: id });
  };

  return (
    <div className="user-place-item" onClick={handleClick} role="button" tabIndex="0">
      <div className="title">{name}</div>
      <div className="data">
        <div className="left">
          <div>{typename}</div>
          <div>{address}</div>
        </div>
        <div className="right">
          <div className="green">{t('userPlaces.scoreApproved')}</div>
          <div className="activity-tasks">
            {t('userPlaces.activityTasks', { count: activeTaskCount })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserPlacesItem;
